// @flow

import projectConfig from '../config/project';

const getDateFormat = (type: string, config: any = projectConfig) =>
  config[`${type}DateFormat`];

export { getDateFormat };
